module.exports = __webpack_public_path__ + "img/calendar.06839661.png";